import React, { Fragment, useMemo } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styled from 'styled-components'

import { useBeforeUnload } from 'hooks'

import { Alert, FadeBox, ProgressBar } from 'ui/chandra'

import { useSurveyContext } from '../_store'

import LayoutContainer from './LayoutContainer'
import LayoutSelector from './LayoutSelector'
import SubmitContainer from './SubmitContainer'

const FadeBoxContainer = styled(FadeBox)`
  &.fade-enter {
    position: absolute;
    opacity: 0;
  }
  &.fade-enter-done {
    position: relative;
    opacity: 1;
  }
`

const Layout = () => {
  const { state, actions, transitionSpeed } = useSurveyContext()
  const step = state.pages[`step_${state.step}`]

  // Alert user if leaving page and survey is not complete yet
  useBeforeUnload(!state.complete)

  const progress = String((step.page.visualStep / step.page.numSteps) * 100.0)

  const closeAlert = () => {
    actions.error(null)
  }

  return useMemo(
    () => (
      <Fragment>
        <ProgressBar color='#826646' fillPercent={progress} />

        <LayoutContainer>
          <TransitionGroup component={null}>
            <CSSTransition
              key={state.step}
              timeout={transitionSpeed}
              classNames='fade'
              appear
              mountOnEnter
              unmountOnExit
              onExited={() => {
                actions.removeStep(state.step)
              }}
            >
              <FadeBoxContainer timeout={transitionSpeed}>
                <LayoutSelector step={state.step} />
              </FadeBoxContainer>
            </CSSTransition>

            <CSSTransition
              key={state.error}
              in={!!state.error}
              timeout={250}
              classNames='fade'
            >
              <FadeBox>
                {state.error && (
                  <Alert
                    type='error'
                    message={state.error}
                    onClose={closeAlert}
                  />
                )}
              </FadeBox>
            </CSSTransition>
          </TransitionGroup>
          <SubmitContainer />
        </LayoutContainer>
      </Fragment>
    ),
    [progress, state.error, state.step]
  )
}

export default Layout
